import { z } from 'zod';

import { zodCallOffItemResponseSchema } from '../validations';

// Re-export the item schema for convenience
export { zodCallOffItemResponseSchema };

// Response schema for list call-off items endpoint
export const zodCallOffItemsListResponseSchema = z.array(
  zodCallOffItemResponseSchema,
);
